<template>
    <div>
        <div class="layui-card-header">
            <blockquote class="layui-elem-quote">
                认定上传资料
            </blockquote>
        </div>

        <div class="layui-card-body">
            <span style="color: red;">
                <i class="layui-icon layui-icon-tips"></i>
                提交审核前先确认认定佐证资料是否已经上传,否则提交审核后将不能进行资料上传操作！
            </span>
            <el-table :data="tableData" style="width: 100%" :border='true' size='medium'>
                <!-- //申报工种 -->
                <el-table-column label="申报工种" width="180" prop="workTypeAlias" :show-overflow-tooltip='true' align='center'>
                </el-table-column>
                <!-- 申报等级  -->
                <el-table-column label="申报等级" width="180" prop="workTypeLevelStateDesc" align='center'>
                </el-table-column>
                <!-- 认定条件总量 -->
                <el-table-column label="认定条件总量" width="120" prop="scienceSumNum" align='center'>
                </el-table-column>
                <!-- 已经上传资料数量 -->
                <el-table-column label="已上传资料数量" width="120" prop="scienceNum" align='center'>
                </el-table-column>
                <!-- 申报状态 -->
                <el-table-column label="申报状态" width="180" align='center'>
                    <template slot-scope="scope">
                        <span v-if="scope.row.declareStatus == 1" style="color: red;">尚未提交审核</span>
                        <span v-if="scope.row.declareStatus == 2" style="color: green;">已提交审核</span>
                    </template>
                </el-table-column>
                <!-- 资料填写时间 -->
                <el-table-column label="资料填写时间" width="180" align='center'>
                    <template slot-scope="scope">
                        <i class="el-icon-time"></i>
                        <span style="margin-left: 10px">{{ scope.row.insertTime }}</span>
                    </template>
                </el-table-column>
                <!-- 编辑 -->
                <el-table-column label="操作" fixed="right" width="380" align='center'>
                    <template slot-scope="scope">

                        <el-button v-if="scope.row.declareStatus == 1 || scope.row.examineStatus == 3 " size="mini" type="primary"
                            @click="handleEdit(scope.row.id,scope.row.workTypeId)">上传资料</el-button>

                        <el-button v-if="scope.row.declareStatus == 1 || scope.row.examineStatus == 3 " size="mini" type="primary"
                            @click="InformationEditing(scope.row)">信息编辑</el-button>

                        <el-button v-if="scope.row.declareStatus == 1 || scope.row.examineStatus == 3" size="mini" type="danger"
                            @click="submitAudit(scope.row)">提交审核</el-button>
                       
                         <el-button v-if="scope.row.declareStatus == 2 && scope.row.examineStatus == 1" size="mini" type="info" disabled>已提交
                        </el-button>

                        <el-button v-if="scope.row.declareStatus == 2 && scope.row.examineStatus == 3 " size="mini" type="info">未通过
                        </el-button>

                        <el-button v-if="scope.row.declareStatus == 2 && scope.row.examineStatus == 2 " size="mini" type="success">已通过
                        </el-button>

                    </template>
                </el-table-column>
            </el-table>

            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="pagesize"
                layout="total, sizes, prev, pager, next, jumper" :total="total">
            </el-pagination>

            <el-dialog title="认定材料上传" :visible.sync="dialogTableVisible" width="50%">
                <el-table :data="thatMaterialList">
                    <el-table-column type="index" label="序号" width="50"></el-table-column>
                    <el-table-column label="认定条件描述" width="200" prop="conditionDesc" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column label="文件" width="200">
                        <template slot-scope="scope">
                            <div v-if="scope.row.userDcId == null">空</div>
                            <div v-if="scope.row.userDcId != null">{{scope.row.scienceName}}</div>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="220" fixed="right">
                        <template slot-scope="scope">
                            <el-button type="success" size="mini" @click="uploadFiles(scope.row)">上传文件</el-button>
                            <el-button type="danger" size="mini" @click="deleteFileRecord(scope.row)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-dialog>

            <el-dialog title="认定材料上传" :visible.sync="dialogTableVisible1" :center="true" width="40%">
                <div class="layui-form-item">
                    <label class="layui-form-label">
                        <span style="color: red;">*</span>文件名称</label>
                    <div class="layui-input-block">
                        <el-input v-model="fileName" placeholder="请输入文件名称" disabled></el-input>
                    </div>
                </div>

                <div class="layui-form-item upload_div">
                    <label class="layui-form-label">
                        <span style="color: red;">*</span>上传文件
                    </label>
                    <div class="layui-upload ">
                        <div class="layui-input-block" style="line-height: 40px;cursor: pointer;">
                            <el-upload class="upload-demo" :action="action" :on-remove="deleteFile" :limit="1"
                                :on-error="errorfile" :on-success="successFile" :file-list="fileList">
                                <el-button size="small" type="primary">点击上传</el-button>
                            </el-upload>
                        </div>
                    </div>
                </div>
                <div class="layui-form-item" style="text-align: center;padding-left:40px;">
                    <a class="layui-btn" @click="saveFile()" style="background-color: #49af4f;color: white;">保存</a>
                    <a type="button" class="layui-btn layui-btn-primary cancel_btn"
                        style="background-color: #999;color: white;">取消</a>
                </div>
            </el-dialog>

            <el-dialog title="信息编辑" custom-class="el-dialog1" :visible.sync="dialogTableVisible2" :center="true"
                width="75%">
                <table class="layui-table" style="margin: 0 auto;">
                    <tbody>
                        <tr style="text-align: center;">
                            <td colspan="10" style="width: 450.00pt;
                                            text-align: center;
                                            font-size: 18px;
                                            font-weight: bold;">
                                职业技能等级认定
                            </td>
                        </tr>
                        <tr>
                            <td colspan="10" style="width: 450.00pt;
                                            color: black;
                                            font-size: 18px;font-weight: 600">
                                基础信息
                            </td>
                        </tr>
                        <tr style="height:28.00pt;">
                            <td style="height:28.00pt;">姓名</td>
                            <td colspan="1">
                                <el-input placeholder="请输入内容" v-model="userName" disabled>
                                </el-input>
                            </td>
                            <td>性别</td>
                            <td colspan="1">
                                <el-radio-group v-model="sex" disabled>
                                    <el-radio :label="1">男</el-radio>
                                    <el-radio :label="2">女</el-radio>
                                </el-radio-group>
                            </td>
                            <td>民族</td>
                            <td colspan="3">
                                <el-select v-model="nation" placeholder="请选择" :disabled="true">
                                    <el-option v-for="(item,index) in nationList" :key="index" :label="item"
                                        :value="item"> </el-option>
                                </el-select>
                            </td>
                            <td rowspan="3" style="text-align: center;">
                                <img v-if="affirmHeadPath" class="profile-image" :src="affirmHeadPath" alt="个人头像">
                            </td>
                        </tr>
                        <tr style="height:28.00pt;">
                            <td colspan="1" style="height:28.00pt;">联系方式</td>
                            <td colspan="2">
                                <el-input placeholder="请输入内容" v-model="phoneNumber" disabled>
                                </el-input>
                            </td>
                            <td style="height:28.00pt;">身份证号</td>
                            <td colspan="4">
                                <el-input placeholder="请输入内容" v-model="idCard" disabled>
                                </el-input>
                            </td>

                        </tr>
                        <tr style="height:28.00pt;">
                            <td style="height:28.00pt;">文化程度</td>
                            <td colspan="2">
                                <el-select v-model="education" placeholder="请选择">
                                    <el-option v-for="(item,index) in educationList" :key="index" :label="item"
                                        :value="item"> </el-option>
                                </el-select>
                            </td>
                            <td colspan="1">政治面貌</td>
                            <td colspan="4">
                                <div class="layui-input-inline" style="width: 210px">
                                    <el-select v-model="politic_countenance" placeholder="请选择">
                                        <el-option v-for="(item,index) in politic_countenanceList" :key="index"
                                            :label="item" :value="item"> </el-option>
                                    </el-select>
                                </div>
                            </td>
                        </tr>
                        <tr style="height:28.00pt;">
                            <td colspan="1"><span style="color: red;">*</span>报名点所在地区</td>
                            <td colspan="2">
                                <el-select v-model="registrationPlace" placeholder="请选择">
                                    <el-option v-for="(item,index) in registrationPlaceList" :key="index"
                                        :label="item.name" :value="item.value"> </el-option>
                                </el-select>
                            </td>
                            <td style="height:28.00pt;"><span style="color: red;">*</span>考生来源</td>
                            <td colspan="6">
                                <div class="layui-form-item" style="margin-bottom: 0px;">
                                    <div class="layui-input-inline" style="width: 210px;margin-right: 14px;">
                                        <el-cascader v-model="candidatesSource" :options="candidatesSourceList"
                                            :props="{ expandTrigger: 'hover' }">
                                        </el-cascader>
                                    </div>
                                </div>
                            </td>

                        </tr>
                        <tr>
                            <td>工作时间</td>
                            <td colspan="2">
                                <el-date-picker style="width:203px" v-model="professionTime" align="center" type="date"
                                    placeholder="选择日期" :picker-options="pickerOptions">
                                </el-date-picker>
                            </td>
                            <td colspan="1">原技术等级</td>
                            <td colspan="3">
                                <div class="layui-input-inline" style="width: 210px">
                                    <div class="layui-unselect layui-form-select">
                                        <el-select v-model="historyWorkTypeLevel" placeholder="请选择">
                                            <el-option v-for="(item,index) in historyWorkTypeLevelList" :key="index"
                                                :label="item.name" :value="item.value"> </el-option>
                                        </el-select>
                                    </div>
                                </div>
                            </td>
                            <td colspan="1"><span style="color: red;">*</span>从事本工种年限</td>
                            <td colspan="1">
                                <el-input placeholder="工种年限" v-model="professionYears">
                                </el-input>
                            </td>

                        </tr>
                        <tr style="height:15.90pt;">
                            <td style="height:30.30pt;">原职业(工种）</td>
                            <td colspan="2">
                                <el-select v-model="historyWorkTypeId" placeholder="请选择">
                                    <el-option v-for="(item,index) in historyWorkTypeIdList" :key="index"
                                        :label="item.name" :value="item.value"> </el-option>
                                </el-select>
                            </td>
                            <td colspan="1">原证书编号</td>
                            <td colspan="3">
                                <el-input style="width:203px" placeholder="请输入原证书编号" v-model="certificateNum">
                                </el-input>
                            </td>
                            <td style="height:30.30pt;">原证书取得(时间）</td>
                            <td colspan="1">
                                <el-date-picker style="width:140px" v-model="historyWorkTypeDate" align="center"
                                    type="date" placeholder="选择日期" :picker-options="pickerOptions">
                                </el-date-picker>

                            </td>
                        </tr>
                    </tbody>
                </table>

                <table class="layui-table" style="margin: 24px auto 0px; position: static;">
                    <tbody>
                        <tr>
                            <td colspan="10" style="width: 450.00pt;font-size: 18px;color: black;font-weight: 600">
                                申报信息
                            </td>
                        </tr>
                        <tr style="height:22.00pt;">
                            <td style="height:22.00pt;"><span style="color: red;">*</span>当前认定职业</td>
                            <td colspan="2">
                                <el-select v-model="workTypeId" placeholder="请选择" @change="currentIdentifiedOccupationChange">
                                    <el-option v-for="(item,index) in historyWorkTypeIdList" :key="index"
                                        :label="item.name" :value="item.value"> </el-option>
                                </el-select>
                            </td>
                            <td style="height:28.00pt;"><span style="color: red;">*</span>鉴定分类</td>
                            <td colspan="3">
                                <el-select v-model="declareClassification" placeholder="请选择">
                                    <el-option v-for="(item,index) in declareClassificationList" :key="index"
                                        :label="item" :value="item"> </el-option>
                                </el-select>
                            </td>
                            <td colspan="1"><span style="color: red;">*</span>当前认定等级</td>
                            <td colspan="1">
                                <el-select v-model="workTypeLevelState" :disabled="true" placeholder="请选择"
                                    style="width: 140px;">
                                    <el-option v-for="(item,index) in historyWorkTypeLevelList" :key="index"
                                        :label="item.name" :value="item.value"> </el-option>
                                </el-select>
                            </td>
                        </tr>
                        <tr style="height:22.00pt;">
                            <td>证书是否邮寄</td>
                            <td colspan="2">
                                <el-radio-group v-model="mailOrNot">
                                    <el-radio :label="2">是</el-radio>
                                    <el-radio :label="1">否</el-radio>
                                </el-radio-group>
                            </td>
                            <td colspan="1" style="height:28.00pt;">证书邮寄地址</td>
                            <td colspan="6">
                                <el-input placeholder="如需要邮寄，请填写邮寄地址" v-model="mailingAddress">
                                </el-input>
                            </td>
                        </tr>
                        <tr style="height:22.00pt;">
                            <td colspan="2" style="height:22.00pt;">工作单位及详细通信地址</td>
                            <td colspan="8">
                                <el-input placeholder="请输入工作单位及详细通讯地址" v-model="detailedAddress">
                                </el-input>
                            </td>
                        </tr>
                        <tr style="height:22.00pt;">
                            <td colspan="2" style="height:22.00pt;">何时何校何专业毕(结)业</td>
                            <td colspan="8">
                                <el-input placeholder="请输入何时何校何专业毕（结）业" v-model="ex1">
                                </el-input>
                            </td>
                        </tr>
                        <tr style="height:22.00pt;">
                            <!-- <td colspan="2" style="height:22.00pt;">何时何地再培训毕(结)业</td>
                            <td colspan="8">
                                <el-input placeholder="请输入何时何地再培训毕（结）业" v-model="ex2">
                                </el-input>
                            </td> -->
                            <td style="height:22.00pt;">毕业院校</td>
                            <td colspan="2">
                                <el-input placeholder="请输入毕业院校" v-model="graduationSchool">
                                </el-input>
                            </td>
                            <td style="height:28.00pt;"><span style="color: red;">*</span>毕业专业</td>
                            <td colspan="3">
                                <el-select v-model="graduationMajor" placeholder="请选择">
                                    <el-option v-for="(item,index) in declareMajorList" :key="index" :label="item.majorName"
                                        :value="item.id"> </el-option>
                                </el-select>
                            </td>
                            <td colspan="1">毕业时间</td>
                            <td colspan="1">
                                <el-input placeholder="请输入毕业时间" v-model="graduationTime">
                                </el-input>
                            </td>
                        </tr>
                        <tr style="height:22.00pt;">
                            <td colspan="2" style="height:22.00pt;"><span style="color: red;">*</span>本人承诺</td>
                            <td colspan="8">
                                <el-input placeholder="本人承诺在XX公司工作X年，XX职位，XX级别" v-model="personalCommitment">
                                </el-input>
                            </td>
                        </tr>
                        <tr style="height: 192px;">
                            <td style="height:75.00pt;">本人简历</td>
                            <td colspan="9">

                                <div id="userResume-editor" class="edui-default">
                                    <quill-editor ref="text" v-model="content" class="myQuillEditor"
                                        :options="editorOption" />
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="9" class="serviceAgreement" style="padding-left: 206px;">


                            </td>
                        </tr>
                    </tbody>
                </table>

                <div class="layui-form-item" style="text-align: center;margin-top: 15px;">
                    <a class="layui-btn layui-btn-sm" @click="saveAffirmInfo">确定保存</a>
                </div>

            </el-dialog>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'app',
        compoents: {

        },
        data() {
            return {
                affirmHeadPath: '',
                state: 0,
                fileName: '',
                fileSrc: '',
                action: '',
                fileList: [],
                dialogVisible: false,
                dialogTableVisible: false,
                dialogTableVisible1: false,
                dialogTableVisible2: false,
                total: 0,   //一共多少条
                pagesize: 10,  //一页几条
                currentPage: 1,//当前页
                tableData: [],//认定列表
                thatMaterialList: [],//认定材料列表
                fileData: {
                    declareUserId: 0, //申报表 id
                    wtcId: 0,//条件表id
                    workTypeId: 0 //工种id
                },
                //信息编辑
                declareUserId: 0,
                editorOption: {
                    modules: {
                        toolbar: [
                            ["bold", "italic", "underline", "strike"], // 加粗 斜体 下划线 删除线
                            ["blockquote", "code-block"], // 引用  代码块
                            [{ header: 1 }, { header: 2 }], // 1、2 级标题
                            [{ list: "ordered" }, { list: "bullet" }], // 有序、无序列表
                            [{ script: "sub" }, { script: "super" }], // 上标/下标
                            [{ indent: "-1" }, { indent: "+1" }], // 缩进
                            // [{'direction': 'rtl'}],                         // 文本方向
                            [{ size: ["small", false, "large", "huge"] }], // 字体大小
                            [{ header: [1, 2, 3, 4, 5, 6, false] }], // 标题
                            [{ color: [] }, { background: [] }], // 字体颜色、字体背景颜色
                            [{ font: [] }], // 字体种类
                            [{ align: [] }], // 对齐方式
                            ["clean"], // 清除文本格式
                            ["link", "image", "video"] // 链接、图片、视频
                        ], //工具菜单栏配置
                    },
                    placeholder: '请在这里添加产品描述', //提示
                    readyOnly: false, //是否只读
                    theme: 'snow', //主题 snow/bubble
                    syntax: true, //语法检测
                },
                content: '',
                sex: 1,
                mailOrNot: 1,//证书 是否邮寄 2是 1否
                mailingAddress: '',// 证书邮寄地址
                detailedAddress: '',//工作地址详细通讯地址
                ex1: '',//何时何校何转业 毕业
                ex2: '',//请输入何时何地再培训毕（结）业
                personalCommitment: '',//本人承诺在XX公司工作X年，XX职位，XX级别
                userName: this.$storage.get('declareUser').userName,
                phoneNumber: this.$storage.get('declareUser').telephone,
                idCard: this.$storage.get('declareUser').idCard,
                nation: '',
                nationList: ['汉族', '蒙古族', '回族', '藏族', '维吾尔族', '苗族', '彝族', '壮族', '布依族', '朝鲜族', '满族'
                    , '侗族', '瑶族', '白族', '土家族', '哈尼族', '哈萨克族', '傣族', '黎族', '傈僳族', '佤族', '畲族', '高山族'
                    , '拉祜族', '水族', '东乡族', '纳西族', '景颇族', '柯尔克孜族', '土族', '达斡尔族', '仫佬族', '羌族', '布朗族'
                    , '撒拉族', '毛南族', '仡佬族', '锡伯族', '阿昌族', '普米族', '塔吉克族', '怒族', '乌孜别克族', '俄罗斯族', '鄂温克族'
                    , '德昂族', '保安族', '裕固族', '裕固族', '京族', '塔塔尔族', '独龙族', '鄂伦春族', '赫哲族', '门巴族', '珞巴族', '基诺族'],
                education: '',
                educationList: ['博士', '研究生', '本科', '专科', '高中', '初中', '小学', '其他'],
                politic_countenance: '',
                politic_countenanceList: ['中共党员', '中共预备党员', '共青团员', '民革党员', '民盟盟员', '民建会员', '民进会员'
                    , '农工党党员', '致公党党员', '九三学社社员', '台盟盟员', '无党派人士', '群众', '其他'],
                registrationPlace: '',
                registrationPlaceList: [{ name: '太原', value: '1' }, { name: '大同', value: '2' }, { name: '忻州', value: '3' }
                    , { name: '阳泉', value: '4' }, { name: '吕梁', value: '5' }, { name: '晋中', value: '6' }, { name: '临汾', value: '7' }
                    , { name: '长治', value: '8' }, { name: '晋城', value: '9' }, { name: '运城', value: '10' }, { name: '朔州', value: '11' }],
                candidatesSource: [],
                candidatesSourceList: [
                    {
                        value: '企业职工', label: '企业职工', children: [{ value: '国有企业', label: '国有企业' }, { value: '私营企业', label: '私营企业' }
                            , { value: '个体企业', label: '个体企业' }, { value: '外商投资', label: '外商投资' }, { value: '港澳台商投资', label: '港澳台商投资' }]
                    },
                    {
                        value: '院校学生', label: '院校学生', children: [{ value: '职业高中', label: '职业高中' }, { value: '普通技工学校', label: '普通技工学校' }
                            , { value: '高级技工学校', label: '高级技工学校' }, { value: '技师学院', label: '职业技术学院' }, { value: '普通中专', label: '普通中专' }
                            , { value: '普通高中', label: '普通高中' }, { value: '普通大专', label: '普通大专' }, { value: '普通大学', label: '普通大学' }
                            , { value: '研究生院', label: '研究生院' }, { value: '其他', label: '其他' }]
                    },
                    { value: '社会人员', label: '社会人员', children: [{ value: '社会人员', label: '社会人员' }] },
                    { value: '机关事业单位', label: '机关事业单位', children: [{ value: '机关事业单位', label: '机关事业单位' }] }],
                professionTime: '',//工作时间
                pickerOptions: {
                    disabledDate(time) {
                        return time.getTime() > Date.now();
                    },
                    shortcuts: [{
                        text: '今天',
                        onClick(picker) {
                            picker.$emit('pick', new Date());
                        }
                    }, {
                        text: '昨天',
                        onClick(picker) {
                            const date = new Date();
                            date.setTime(date.getTime() - 3600 * 1000 * 24);
                            picker.$emit('pick', date);
                        }
                    }, {
                        text: '一周前',
                        onClick(picker) {
                            const date = new Date();
                            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', date);
                        }
                    }]
                },
                historyWorkTypeLevel: '',
                historyWorkTypeLevelList: [{ name: '高级技师', value: 1 }, { name: '技师', value: 2 }, { name: '三级（高级工）', value: 3 },
                { name: '四级（中级工）', value: 4 }, { name: '五级（初级工）', value: 5 }],
                professionYears: '',//工种年限
                historyWorkTypeId: 0,
                historyWorkTypeIdList: [],
                certificateNum: '',
                historyWorkTypeDate: '',
                workTypeId: '',
                declareClassification: '',
                declareClassificationList: ['初次鉴定', '晋级鉴定', '补考鉴定'],
                workTypeLevelState: 0,
                graduationMajor:'',//毕业专业
                graduationSchool:'',//毕业院校
                graduationTime:'',//毕业时间
                declareMajorList:[]

            }
        },
        created() {
            this.state = this.$route.params.state;
            this.workTypeLevelState = parseInt(this.$route.params.workTypeLevelState);
            this.action = this.serverUrl + '/deUp/uploadDeclareResource';
            this.loadData(this.currentPage, this.pagesize);

            //加载职业工种
            this.loadWorkType();
        },
        mounted() {

        },
        methods: {
            currentIdentifiedOccupationChange(){
                let parames = new URLSearchParams();
                parames.append('workTypeId', this.workTypeId) 
                 this.$axios.post(this.serverUrl + '/dict/getMajorList', parames).then(resp => {


                    if (resp.data.code === 1) {

                        this.declareMajorList = resp.data.data;

                    }



                }).catch(err => {
                    console.log(err);
                })

            },
            loadWorkType() {
                var params = new URLSearchParams();
                params.append('userType', '1');
                params.append('groupType', '1');
                params.append('workTypeGradeOpen', this.workTypeLevelState);
                this.$axios.post(this.serverUrl + '/getGroupList', params).then(resp => {
                    resp.data.data.forEach(element => {
                        let historyWork = {
                            name: '',
                            value: ''
                        }
                        historyWork.name = element.workTypeName;
                        historyWork.value = element.workTypeId;
                        this.historyWorkTypeIdList.push(historyWork);
                    });
                }).catch(err => {
                    this.$message('工种列表加载失败！');
                })
            },
            //信息编辑
            InformationEditing(row) {
                this.declareUserId = row.id;
                let parames = new URLSearchParams();
                console.log(row.id)
                parames.append('declareUserId', row.id);
                this.$axios.post(this.serverUrl + '/selectDeclareUser', parames).then(resp => {
                    this.userName = resp.data.DeclareUserInfoView.userName;
                    this.sex = resp.data.DeclareUserInfoView.sex;  //性别
                    this.nation = resp.data.DeclareUserInfoView.nation; //民族
                    this.idCard = resp.data.DeclareUserInfoView.idCard;

                    this.affirmHeadPath = this.serverUrl + this.prefiexUrl + resp.data.DeclareUserInfoView.headPath;

                    this.education = resp.data.DeclareUserInfoView.education; //学历
                    this.politic_countenance = resp.data.DeclareUserInfoView.politic_countenance; //政治面貌
                    this.registrationPlace = resp.data.DeclareUserInfoView.registrationPlace;//报名点所在地
                    let ArrayList = [];
                    ArrayList.push(resp.data.DeclareUserInfoView.candidatesSource);
                    ArrayList.push(resp.data.DeclareUserInfoView.candidatesSourceSon)
                    this.candidatesSource = ArrayList;

                    if (resp.data.DeclareUserInfoView.professionTime != null) {
                        this.professionTime = resp.data.DeclareUserInfoView.professionTime;//参加本职业（工种）时间
                    }


                    this.historyWorkTypeLevel = resp.data.DeclareUserInfoView.historyWorkTypeLevel;//原技术等级


                    this.professionYears = resp.data.DeclareUserInfoView.professionYears;//参加本职业工种年限

                    this.historyWorkTypeId = resp.data.DeclareUserInfoView.historyWorkTypeId;//原职业工种id


                    this.certificateNum = resp.data.DeclareUserInfoView.certificateNum;//原证书编号

                    if (resp.data.DeclareUserInfoView.historyWorkTypeDate != null) {
                        this.historyWorkTypeDate = resp.data.DeclareUserInfoView.historyWorkTypeDate;//原证书取得时间
                    }



                    this.workTypeId = resp.data.DeclareUserInfoView.workTypeId;//认定职业工种id
                    this.currentIdentifiedOccupationChange();

                    this.declareClassification = resp.data.DeclareUserInfoView.declareClassification;//鉴定分类
                    this.mailOrNot = resp.data.DeclareUserInfoView.mailOrNot; //证书是否需要邮寄 1不邮寄 2 邮寄
                    this.mailingAddress = resp.data.DeclareUserInfoView.mailingAddress; //证书邮寄地址
                    this.detailedAddress = resp.data.DeclareUserInfoView.detailedAddress;//公司所在详细地址
                    
                    this.ex2 = resp.data.DeclareUserInfoView.workExperiences[0].experienceDesc;// 何时何地再培调毕(结)业
                    

                    this.graduationMajor = resp.data.DeclareUserInfoView.workExperiences[0].graduationMajor;//毕业专业
                    this.graduationSchool = resp.data.DeclareUserInfoView.workExperiences[0].graduationSchool;//毕业院校
                    this.graduationTime = resp.data.DeclareUserInfoView.workExperiences[0].graduationTime;//毕业时间

                  /*   resp.data.DeclareUserInfoView.workExperiences.forEach(val => {
                        if (val.exState === 1) {
                            this.ex1 = val.experienceDesc;// 何时何校何专业毕(结)业
                        } else {
                            this.ex2 = val.experienceDesc;// 何时何地再培调毕(结)业
                        }
                    }) */
                    this.personalCommitment = resp.data.DeclareUserInfoView.personalCommitment;//本人承诺

                    this.content = resp.data.DeclareUserInfoView.userResume;//个人简历

                    this.dialogTableVisible2 = true;


                }).catch(err => {

                })

            },
            //返回年月日
            dateStringTransition(date) {
                var year = date.getFullYear(); //获取完整的年份(4位,1970-????)
                var month = date.getMonth() + 1; //获取当前月份(0-11,0代表1月)
                var day = date.getDate(); //获取当前日(1-31)
                if (month < 10) {
                    month = "0" + month;
                }
                if (day < 10) {
                    day = "0" + day;
                }
                return year + "-" + month + "-" + day + " 00:00:00";
            },
            //编辑保存            
            saveAffirmInfo() {
                let experienceDesc = '';

                if (this.ex1 != '' && this.ex2 != '') {
                    experienceDesc = "1-" + this.ex1 + "," + "2-" + this.ex2;
                }

                if (this.ex1 != '' && this.ex2 === '') {
                    experienceDesc = "1-" + this.ex1;
                }

                if (this.ex2 != '' && this.ex1 === '') {
                    experienceDesc = "2-" + this.ex2;
                }

                let parames = new URLSearchParams();
                parames.append('id', this.declareUserId);
                //parames.append('userName',this.userName);
                //parames.append('sex',this.sex);
                parames.append('userId', this.$storage.get('declareUser').id);

                //parames.append('idCard',this.idCard);
                parames.append('registrationPlace', this.registrationPlace);//报名所在地
                parames.append('candidatesSource', this.candidatesSource[0]);//考生来源
                parames.append('candidatesSourceSon', this.candidatesSource[1]);//考生来源子集

                if (this.professionTime != '' && this.professionTime != null) {

                    if (typeof (this.professionTime) === 'string') {
                        parames.append('professionTime', this.professionTime + " 00:00:00");//工作时间
                    } else {
                        parames.append('professionTime', this.dateStringTransition(this.professionTime));//工作时间
                    }

                }

                if (this.historyWorkTypeLevel != null) {
                    parames.append('historyWorkTypeLevel', this.historyWorkTypeLevel); //原技术等级
                }

                parames.append('professionYears', this.professionYears);  //工种年限

                if (this.historyWorkTypeId != null) {
                    parames.append('historyWorkTypeId', this.historyWorkTypeId);  //原职业工种id
                }

                if (this.certificateNum != null) {
                    parames.append('certificateNum', this.certificateNum); //原证书编号
                }


                if (this.historyWorkTypeDate != '' && this.historyWorkTypeDate != null) {
                    if (typeof (this.historyWorkTypeDate) === 'string') {
                        parames.append('historyWorkTypeDate', this.historyWorkTypeDate + " 00:00:00"); //原证书取得时间
                    } else {
                        parames.append('historyWorkTypeDate', this.dateStringTransition(this.historyWorkTypeDate)); //原证书取得时间
                    }
                }

                parames.append('workTypeId', this.workTypeId);  //当前认定职业工种
                parames.append('declareClassification', this.declareClassification); //鉴定分类
                parames.append('workTypeLevelState', this.workTypeLevelState) //当前申报等级
                parames.append('mailOrNot', this.mailOrNot);  //证书是否邮寄
                if (this.mailingAddress != null) {
                    parames.append('mailingAddress', this.mailingAddress); //证书邮寄地址
                }

                parames.append('experienceDesc', experienceDesc); // 何时何校何专业毕(结)业 , 何时何地再培训毕(结)业 

                if (this.detailedAddress != null) {
                    parames.append('detailedAddress', this.detailedAddress);//工作单位及详细通信地址
                }

                parames.append('personalCommitment', this.personalCommitment); //个人承诺

                if (this.content != null) {
                    parames.append('userResume', this.content);//本人简历
                }

                this.$axios.post(this.serverUrl + '/updateDeclare', parames).then(resp => {


                    if (resp.data.code === '4001') {

                        this.$message({
                            showClose: true,
                            message: '请求过于频繁,于一分钟后重试！',
                            type: 'error'
                        })

                    } else if (resp.data.code === '4000' || resp.data.code === '4002' || resp.data.code === '4003') {
                        this.$confirm('登录超时！请重新登录').then(_ => {
                            this.$router.push('/login');
                        }).catch(_ => { });
                    } else {
                        if (resp.data.code === 1) {

                            this.$message({
                                message: '恭喜你，更新成功',
                                type: 'success'
                            });

                            this.dialogTableVisible2 = false;

                        }
                    }



                }).catch(err => {
                    console.log(err);
                })
            },
            //提交审核
            submitAudit(row) {

                this.$confirm('提交审核之后将不能上传资料，确认提交?', '提示', {
                    cancelButtonText: '取消',
                    confirmButtonText: '确定',
                    type: 'warning'
                }).then(() => {

                    const loading = this.$loading({
                        lock: true,
                        text: '信息提交中，请稍后...',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });

                    let parames = new URLSearchParams();
                    parames.append('id', row.id);
                    parames.append('declareStatus', 2);
                    parames.append('examineStatus', 1);
                    this.$axios.post(this.serverUrl + '/updateDeclareUserOcccpationState', parames).then(resp => {

                        if (resp.data.code === 1) {

                            loading.close();
                            //刷新thatMaterialList数据
                            this.loadData(this.currentPage, this.pagesize);

                            this.$message({
                                message: '恭喜你！提交审核成功！',
                                type: 'success'
                            });
                        } else {
                            this.$message.error('提交审核失败！');
                        }

                    }).catch(err => {

                    })

                }).catch(() => {

                });

            },
            //删除文件
            deleteFile(file, fileList) {

                let parames = new URLSearchParams();
                parames.append('filePath', this.fileSrc);

                this.$axios.post(this.serverUrl + '/deUp/delFile', parames).then(resp => {
                    if (resp.data.code === 1) {
                        this.$message({
                            showClose: true,
                            message: '恭喜你，文件删除成功！',
                            type: 'success'
                        });
                    }
                }).catch(err => {
                })
            },
            successFile(response, file, fileList) {
                this.fileSrc = response.src;
                this.fileName = file.name.substring(0, file.name.lastIndexOf("."));
                this.$message({
                    showClose: true,
                    message: '恭喜你，文件上传成功！',
                    type: 'success'
                });
            },
            errorfile() {
                this.$message.error('上传资料失败！请稍后再试！');
            },
            //切换每页多少条 触发
            handleSizeChange(val) {
                console.log(`每页dusoaho条`);
                this.pagesize = val;
                this.loadData(this.currentPage, this.pagesize);
            },
            //第几页切换的时 触发
            handleCurrentChange(val) {
                this.currentPage = val;
                this.loadData(this.currentPage, this.pagesize);
            },
            //根据标识返回认定等级
            getWorkTypeLevelStateDesc(level) {
                var workTypeLevelStateDesc = '';
                switch (level) {
                    case 1:
                        workTypeLevelStateDesc = "高级技师";
                        break; //可选
                    case 2:
                        //语句
                        workTypeLevelStateDesc = "技师";
                        break; //可选
                    case 3:
                        //语句
                        workTypeLevelStateDesc = "三级（高级工）";
                        break; //可选
                    case 4:
                        //语句
                        workTypeLevelStateDesc = "四级（中级工）";
                        break; //可选
                    default: //可选
                        //语句
                        workTypeLevelStateDesc = "五级（初级工）";
                }
                return workTypeLevelStateDesc;
            },
            //加载认定完需要提交资料的列表
            loadData(page, limit) {
                let parames = new URLSearchParams();
                parames.append('levelState', this.$route.params.workTypeLevelState);
                parames.append('userId', this.$storage.get('declareUser').id);
                parames.append('page', page);
                parames.append('limit', limit);

                if (this.state == 2) {
                    parames.append('declareCode', this.declareCode);
                }
                //获取 当前等级下的上传资料 列表
                this.$axios.post(this.serverUrl + '/getUserDeclareOccupationData', parames).then(resp => {

                    this.total = resp.data.count;
                    if (resp.data.code === 1) {
                        let ArrayList = [];
                        resp.data.data.forEach(element => {
                            let UserDeclareOccupationData = {
                                id: '',//申报主表id
                                workTypeAlias: '',//申报工种名称
                                workTypeLevelState: 0,//申报等级
                                workTypeLevelStateDesc: '',
                                workTypeId: 0,
                                examineStatus:0,
                                scienceSumNum: 0,//当前工种申报等级所需上传认定条件资料总量
                                scienceNum: 0,  //当前工种申报等级下的材料数量-每种条件只能上传一份材料
                                declareStatus: 0,////申报状态  1确定申报  2取消申报  3.申报中 2020年10月23日09:19:08  liqi  新增申报中状态
                                insertTime: ''//资料填写时间
                            };
                            UserDeclareOccupationData.id = element.id;
                            UserDeclareOccupationData.workTypeAlias = element.workTypeAlias;
                            UserDeclareOccupationData.workTypeLevelState = element.workTypeLevelState;
                            UserDeclareOccupationData.workTypeLevelStateDesc = this.getWorkTypeLevelStateDesc(element.workTypeLevelState);
                            UserDeclareOccupationData.workTypeId = element.workTypeId;
                            UserDeclareOccupationData.scienceSumNum = element.scienceSumNum; //需要上传数 
                            UserDeclareOccupationData.scienceNum = element.scienceNum; //已经上传数量
                            UserDeclareOccupationData.declareStatus = element.declareStatus;
                            UserDeclareOccupationData.insertTime = element.insertTime.substring(0, 10);
                            UserDeclareOccupationData.examineStatus = element.examineStatus;
                            
                            ArrayList.push(UserDeclareOccupationData);
                        });
                        this.tableData = ArrayList;
                    }

                }).catch(err => {
                    console.log(err);
                })
            },
            //上传资料 显示 认定需要上传资料列表
            handleEdit(declareUserId, workTypeId) {
                this.fileData.declareUserId = declareUserId;
                this.fileData.workTypeId = workTypeId;
                let parames = new URLSearchParams();
                parames.append('levelState', this.$route.params.workTypeLevelState); //
                parames.append('declareUserId', declareUserId);
                parames.append('workTypeId', workTypeId);
                parames.append('userId', this.$storage.get('declareUser').id);
                //根据当前职业工种 查询当前用户下的当前等级下的 当前职业工种下的认定资料上传情况列表
                this.$axios.post(this.serverUrl + '/getLevelCondtionData', parames).then(resp => {
                    this.total = resp.data.count;
                    if (resp.data.code === 1) {
                        let ArrayList = [];
                        resp.data.data.forEach(element => {
                            let UserDeclareOccupationData = {
                                dcId: 0,//条件ID
                                conditionDesc: '',//条件描述
                                levelState: 0,//职业|工种等级 职业等级1.2.3.4.5
                                userDcId: 0,
                                scienceName: '',//用户上传材料名称
                            };

                            UserDeclareOccupationData.dcId = element.dcId;
                            UserDeclareOccupationData.conditionDesc = element.conditionDesc;
                            UserDeclareOccupationData.levelState = element.levelState;
                            UserDeclareOccupationData.userDcId = element.userDcId;
                            UserDeclareOccupationData.scienceName = element.scienceName;
                            ArrayList.push(UserDeclareOccupationData);
                        });

                        this.thatMaterialList = ArrayList;
                    }

                }).catch(err => {
                })

                this.dialogTableVisible = true;
            },
            //上传文件 对应每个条件上传
            uploadFiles(row) {
                if (row.userDcId != null) {

                    this.$message({
                        message: '该条件已经上传过文件，请先将其删除后再上传！',
                        type: 'warning'
                    });

                    return false;
                }
                this.fileName = '';
                this.fileData.wtcId = row.dcId;
                this.dialogTableVisible1 = true;
            },
            //删除文件加 该条件下的记录
            deleteFileRecord(row) {
                if (row.userDcId === null) {
                    this.$message.error('暂未上传文件！');
                    return false;
                }
                this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let parames = new URLSearchParams();
                    parames.append('id', row.userDcId);
                    //根据当前职业工种 查询当前用户下的当前等级下的 当前职业工种下的认定资料上传情况列表
                    this.$axios.post(this.serverUrl + '/deleteDeclareUserConditionScience', parames).then(resp => {

                        this.total = resp.data.count;
                        if (resp.data.code === 1) {
                            this.handleEdit(this.fileData.declareUserId, this.fileData.workTypeId);
                            this.$message({
                                message: '恭喜你，删除成功！',
                                type: 'success'
                            });
                        }


                    }).catch(err => {

                    })
                }).catch(() => {


                });
            },
            // 上传文件保存
            saveFile() {
                let parames = new URLSearchParams();
                parames.append('workTypeLevelState', this.$route.params.workTypeLevelState);
                parames.append('declareUserId', this.fileData.declareUserId);
                parames.append('wtcId', this.fileData.wtcId);
                parames.append('scienceName', this.fileName);
                parames.append('scienceSrc', this.fileSrc);
                parames.append('userId', this.$storage.get('declareUser').id);
                this.$axios.post(this.serverUrl + '/addDeclareUserConditionScience', parames).then(resp => {
                    if (resp.data.code === 1) {
                        //刷新thatMaterialList数据
                        this.handleEdit(this.fileData.declareUserId, this.fileData.workTypeId);
                        //清除
                        this.oldName = '';
                        this.fileList = [];

                        this.dialogTableVisible1 = false;
                        this.$message({
                            message: '恭喜你，保存成功！',
                            type: 'success'
                        });
                    } else {
                        this.$message.error('错了哦，保存失败！');
                    }

                }).catch(err => {

                })
            }
        }
    }
</script>

<style scoped>
    div /deep/ input[type=file] {
        display: none;
    }

    .el-dialog1 {
        position: relative;
        margin: 0 auto 50px;
        border-radius: 2px;
        -webkit-box-shadow: 0 1px 3px rgba(0, 0, 0, .3);
        box-shadow: 0 1px 3px rgba(0, 0, 0, .3);
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        width: 70%;
        height: 650px;
        overflow: scroll;
        margin-top: 5vh !important;
    }

    .layui-btn+.layui-btn {
        margin-left: 10px;
    }

    .layui-btn {
        display: inline-block;
        height: 38px;
        line-height: 38px;
        padding: 0 18px;
        background-color: #009688;
        color: #fff;
        white-space: nowrap;
        text-align: center;
        font-size: 14px;
        border: none;
        border-radius: 2px;
        cursor: pointer;
    }

    .layui-btn-sm {
        height: 30px;
        line-height: 30px;
        padding: 0 10px;
        font-size: 12px;
    }

    .layui-form-item {
        margin-bottom: 15px;
        clear: both;
        *zoom: 1;
    }

    .el-checkbox__input {
        cursor: pointer;
        outline: 0;
        /* line-height: 1; */
        vertical-align: unset;
    }

    .cu-modal.show {
        opacity: 1;
        transition-duration: 0.1s;
        transform: scale(1);
        pointer-events: auto;
    }

    .cu-modal {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        opacity: 0;
        outline: 0;
        z-index: 999;
        text-align: center;
        transform: scale(100);
        backface-visibility: hidden;
        background: rgba(0, 0, 0, 0.6);
        transition: all 2 ease 2;
        pointer-events: none;
    }

    .ql-toolbar.ql-snow+.ql-container.ql-snow {
        border-top: 0px;
        height: 120px;
    }

    .editor {
        line-height: normal !important;
        height: 800px;
    }

    .ql-snow .ql-tooltip[data-mode=link]::before {
        content: "请输入链接地址:";
    }

    .ql-snow .ql-tooltip.ql-editing a.ql-action::after {
        border-right: 0px;
        content: '保存';
        padding-right: 0px;
    }

    .ql-snow .ql-tooltip[data-mode=video]::before {
        content: "请输入视频地址:";
    }

    .ql-snow .ql-picker.ql-size .ql-picker-label::before,
    .ql-snow .ql-picker.ql-size .ql-picker-item::before {
        content: '14px';
    }

    .ql-snow .ql-picker.ql-size .ql-picker-label[data-value=small]::before,
    .ql-snow .ql-picker.ql-size .ql-picker-item[data-value=small]::before {
        content: '10px';
    }

    .ql-snow .ql-picker.ql-size .ql-picker-label[data-value=large]::before,
    .ql-snow .ql-picker.ql-size .ql-picker-item[data-value=large]::before {
        content: '18px';
    }

    .ql-snow .ql-picker.ql-size .ql-picker-label[data-value=huge]::before,
    .ql-snow .ql-picker.ql-size .ql-picker-item[data-value=huge]::before {
        content: '32px';
    }

    .ql-snow .ql-picker.ql-header .ql-picker-label::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item::before {
        content: '文本';
    }

    .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="1"]::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="1"]::before {
        content: '标题1';
    }

    .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="2"]::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="2"]::before {
        content: '标题2';
    }

    .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="3"]::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="3"]::before {
        content: '标题3';
    }

    .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="4"]::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="4"]::before {
        content: '标题4';
    }

    .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="5"]::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="5"]::before {
        content: '标题5';
    }

    .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="6"]::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="6"]::before {
        content: '标题6';
    }

    .ql-snow .ql-picker.ql-font .ql-picker-label::before,
    .ql-snow .ql-picker.ql-font .ql-picker-item::before {
        content: '标准字体';
    }

    .ql-snow .ql-picker.ql-font .ql-picker-label[data-value=serif]::before,
    .ql-snow .ql-picker.ql-font .ql-picker-item[data-value=serif]::before {
        content: '衬线字体';
    }

    .ql-snow .ql-picker.ql-font .ql-picker-label[data-value=monospace]::before,
    .ql-snow .ql-picker.ql-font .ql-picker-item[data-value=monospace]::before {
        content: '等宽字体';
    }

    .el-select .el-input__inner:focus {
        border-color: #969696;
    }

    .el-select .el-input.is-focus .el-input__inner {
        border-color: #969696;
    }

    .el-radio-button__inner,
    .el-radio-group {
        display: inline-block;
        line-height: 1;
        vertical-align: middle;
        display: flex;
    }

    .el-radio__label {
        font-size: 14px;
        padding-left: 5px;
    }

    .layui-table td {
        position: relative;
        padding: 9px 9px;
        min-height: 20px;
        line-height: 20px;
        font-size: 14px;
        width: 96px !important;
        border-width: 1px;
        border-style: solid;
        border-color: #e6e6e6;
    }

    .el-radio__input.is-checked+.el-radio__label {
        color: #5FB878;
    }

    .el-radio__input.is-checked .el-radio__inner {
        border-color: #5FB878;
        background: #5FB878;
    }

    .layui-form-radio {
        line-height: 28px;
        margin: 6px 10px 0 0;
        padding-right: 10px;
        cursor: pointer;
        font-size: 0;
    }

    .lrspb .layui-form-radio {
        margin: 6px 0px 0 0;
        padding-right: 2px;
    }

    button,
    input,
    optgroup,
    option,
    select,
    textarea {
        font-family: inherit;
        font-size: inherit;
        font-style: inherit;
        font-weight: inherit;
        outline: 0;
    }

    .lrspb .ux-input_base {
        height: 33px;
        width: 89%;
    }

    .layui-table {
        width: 100%;
        background-color: #fff;
        color: #666;
    }







    .el-dialog--center .el-dialog__body {
        text-align: initial;
    }

    .layui-form-label {
        float: left;
        display: block;
        padding: 9px 15px;
        width: 90px;
        font-weight: 400;
        line-height: 20px;
        text-align: right;
    }

    .layui-form-item {
        margin-bottom: 15px;
        clear: both;
        *zoom: 1;
    }

    .el-button--mini,
    .el-button--mini.is-round {
        padding: 5px 10px;
    }

    .el-radio__input.is-checked+.el-radio__label {
        color: #5FB878;
    }

    .el-radio__input.is-checked .el-radio__inner {
        border-color: #5FB878;
        background: #5FB878;
    }

    select {
        display: none;
    }

    .layui-edge {
        display: inline-block;
        width: 0;
        height: 0;
        border-width: 6px;
        border-style: dashed;
        border-color: transparent;
    }

    .layui-form-select .layui-edge {
        position: absolute;
        right: 10px;
        top: 50%;
        margin-top: -3px;
        cursor: pointer;
        border-width: 6px;
        border-top-color: #c2c2c2;
        border-top-style: solid;
        transition: all .3s;
        -webkit-transition: all .3s;
    }

    .layui-form-select dl dd,
    .layui-form-select dl dt {
        padding: 0 10px;
        line-height: 36px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .layui-form-select dl dd {
        cursor: pointer;
    }

    .layui-form-select dl dd.layui-this {
        background-color: #5FB878;
        color: #fff;
    }

    .layui-form-select dl dd.layui-select-tips {
        padding-left: 10px !important;
        color: #999;
    }

    dl {
        display: none;
        position: absolute;
        left: 0;
        top: 42px;
        padding: 5px 0;
        z-index: 899;
        min-width: 100%;
        border: 1px solid #d2d2d2;
        max-height: 300px;
        overflow-y: auto;
        background-color: #fff;
        border-radius: 2px;
        box-shadow: 0 2px 4px rgba(0, 0, 0, .12);
        box-sizing: border-box;
    }

    .layui-input,
    .layui-textarea {
        display: block;
        width: 100%;
        padding-left: 10px;
        height: 38px;
        line-height: 1.3;
        line-height: 38px\9;
        border-width: 1px;
        border-style: solid;
        background-color: #fff;
        border-radius: 2px;
    }

    .layui-form-select .layui-input {
        padding-right: 30px;
        cursor: pointer;
    }

    .layui-form-label,
    .layui-form-mid,
    .layui-form-select,
    .layui-input-block,
    .layui-input-inline,
    .layui-textarea {
        position: relative;
    }

    .layui-input-inline {
        display: inline-block;
        vertical-align: middle;
    }

    button,
    input,
    optgroup,
    option,
    select,
    textarea {
        font-family: inherit;
        font-size: inherit;
        font-style: inherit;
        font-weight: inherit;
        outline: 0;
    }

    .layui-btn {
        display: inline-block;
        height: 38px;
        line-height: 38px;
        padding: 0 18px;
        background-color: #009688;
        color: #fff;
        white-space: nowrap;
        text-align: center;
        font-size: 14px;
        border: none;
        border-radius: 2px;
        cursor: pointer;
    }

    .layui-btn-normal {
        background-color: #1E9FFF;
    }

    .layui-btn-sm {
        height: 30px;
        line-height: 30px;
        padding: 0 10px;
        font-size: 12px;
    }

    .layui-anim.layui-icon {
        display: inline-block;
    }

    .layui-form-radio>i {
        margin-right: 8px;
        font-size: 22px;
        color: #c2c2c2;
    }

    .layui-form-radio {
        display: inline-block;
        vertical-align: middle;
        line-height: 28px;
        margin: 6px 10px 0 0;
        padding-right: 10px;
        cursor: pointer;
        font-size: 0;
    }

    .layui-input-block {
        margin-left: 110px;
        min-height: 36px;
    }

    .ux-input_base {
        padding: .16rem .32rem;
        font-size: 14px;
        border: 1px solid #ddd;
        color: #555;
        background: #fff;
        border-radius: 2px;
        vertical-align: middle;
    }

    .ux-input2,
    .ux-textarea2 {
        display: inline-block;
        position: relative;
        white-space: nowrap;
    }

    .userInfo .layui-icon-tips {
        font-size: 13px;
    }

    .layui-show {
        display: block !important;
    }

    .layui-upload-drag .layui-icon {
        font-size: 50px;
        color: #009688;
    }

    .layui-upload-file {
        display: none !important;
        opacity: .01;
        filter: Alpha(opacity=1);
    }

    .layui-upload-drag {
        position: relative;
        padding: 30px;
        border: 1px dashed #e2e2e2;
        background-color: #fff;
        text-align: center;
        cursor: pointer;
        color: #999;
    }

    .layui-upload-drag {
        border: 1px solid #5fb878;
    }

    .layui-icon {
        font-family: layui-icon !important;
        font-size: 16px;
        font-style: normal;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }

    .userInfo .layui-icon-tips {
        font-size: 13px;
    }

    .input-row-right input[type="text"] {
        width: 400px;
        height: 30px;
    }

    .ux-input2,
    .ux-textarea2 {
        display: inline-block;
        position: relative;
        white-space: nowrap;
    }

    .profile-image-upload {
        text-align: center;
        position: relative;
        vertical-align: top;
        display: inline-block;
        border-radius: 50%;
        width: 104px;
        height: 104px;
        background-repeat: no-repeat;
        background-position: center;
        background-image: url(/jnrd/img/profile-image.png);
    }

    .input-row-right {
        font-size: 12px;
        width: 690px;
        text-align: left;
        display: inline-block;
        vertical-align: top;
        text-align: left;
        padding-top: 20px;
        padding-bottom: 20px;
    }

    .input-row-left {
        width: 100px;
        text-align: left;
        padding-left: 50px;
        display: inline-block;
        vertical-align: top;
        text-align: left;
        padding-top: 20px;
        padding-bottom: 20px;
    }

    .f-cb:after {
        display: block;
        clear: both;
        visibility: hidden;
        height: 0;
        overflow: hidden;
        content: ".";
    }

    .layui-card-body {
        position: relative;
        padding: 10px 15px;
        line-height: 24px;
    }

    .layui-card-header {
        position: relative;
        height: 42px;
        line-height: 42px;
        padding: 0 15px;
        border-bottom: 1px solid #f6f6f6;
        color: #333;
        border-radius: 2px 2px 0 0;
        font-size: 14px;
    }

    .u-gx-ttop {
        border-bottom: none;
        margin: 0 15px;
        height: 38px;
        padding: 10px 0;
    }

    .f-fc9 {
        color: #999;
    }

    .f-f0 {
        font-family: "Arial", "Hiragino Sans GB", \5fae\8f6f\96c5\9ed1, "Helvetica", "sans-serif";
    }

    .f-fl {
        float: left;
    }
</style>


// WEBPACK FOOTER //
// src/components/affirm/affirmUploadData.vue